// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"Sidebar_logoContainer__1Og9N","logo":"Sidebar_logo__jVn7Z","container":"Sidebar_container__2BWmN","menuContainer":"Sidebar_menuContainer__1faC_"};